export default "__VITE_ASSET__BirxLHrC__"